import { DefaultButton, PrimaryButton } from "@fluentui/react";
import Moment from "moment";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import styles from "../Hospital/hospital.module.css";
import { ACTIONS, AuthRoutes, USERTYPES } from "../../constants/Constants";
const ColumnsClient = (handleClickGroup, userRole) => {
  const [t, i18n] = useTranslation();
  // const childTrPadding =
  //   process.env.REACT_APP_HYBRID_MODE == "false" ? "15px 5px" : "15px 10px";

    const childTrPadding = (process.env.REACT_APP_HYBRID_MODE == "false") ? "15px 0px 15px 10px" : "15px 10px";
    const rowTrPadding = "0px 10px";

  return [
    {
      id: "username",
      style: { width: "15vw", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: { padding: "15px 0px 15px 10px", textAlign: "left",boxSizing:'border-box' },
      headerClass: "break-word column-user-details-header",
      classChildName: "break-word cursor-pointer",
      header: () => <span className="">Details</span>,
      accessor: "clients",
      accessorKey: "clients",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Name</div>
            <div className="user-sub-heading">{cell.row.original.name}</div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">Address</div>
            <div className="user-sub-heading">{cell.row.original.address}</div>
          </div>
        </>
      ),
    },
    {
      id: "email",
      style: { width: "20vw", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "20vw !important",
        boxSizing:'border-box'
      },
      headerClass: "break-word column-user-contact-header",
      classChildName: "break-word cursor-pointer column-user-contact-header",
      header: () => <span className="">Contact Details</span>,
      accessor: "email",
      accessorKey: "email",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">{t("user.email")}</div>
            <div className="user-sub-heading">
              {userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN
                ? cell.row.original?.email === ""
                  ? "-"
                  : cell.row.original?.email
                : cell.row.original?.contact1 === null ||
                  cell.row.original?.contact1?.email === ""
                ? "-"
                : cell.row.original?.contact1?.email}
            </div>
          </div>

          <div className="user-mt-10">
            <div className="user-heading">{t("user.mobile")}</div>
            <div className="user-sub-heading">
              {userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST || userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN
                ? cell.row.original?.mobileNo === ""
                  ? "-"
                  : cell.row.original?.mobileNo
                : cell.row.original?.contact1 === null ||
                  cell.row.original?.contact1?.mobile === ""
                ? "-"
                : cell.row.original?.contact1?.mobile}
            </div>
          </div>
        </>
      ),
    },
    {
      id: "Type",
      style: { width: "15vw", boxSizing:'border-box',padding:rowTrPadding },
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "15vw !important",
        boxSizing:'border-box'
      },
      headerClass: "break-word column-firm-type-header",
      classChildName: "break-word cursor-pointer column-firm-type-header",
      header: () => <span className="">{userRole === USERTYPES.FIRMDOCTOR || userRole === USERTYPES.FIRMTECHNICIAN ? "Type" : "Status"}</span>,
      accessor: "type",
      accessorKey: "type",
      show: true,
      cell: (cell) => (
        <>
          <div>
            <div className="user-heading">Type</div>
            <div className="user-sub-heading">{cell.row.original.firmType}</div>
          </div>

          {userRole != USERTYPES.FIRMDOCTOR && userRole != USERTYPES.FIRMTECHNICIAN && <div className="user-mt-10">
            <div className="user-heading">Connection Status</div>
            <div className="user-sub-heading">
              {((userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST) &&
                cell.row.original.status !== "Active") ||
              (userRole === USERTYPES.ADMIN &&
                cell.row.original.active === false)
                ? <><span className="inactive-red-dot"></span>{t("hospital.inactive")}</>
                : <><span className="active-green-dot"></span>{t("hospital.active")}</>}
            </div>
          </div>}
        </>
      ),
    },
    {
      id: "action",
      style: {
        width: "15vw",
        display: "flex",
        height: "80px",
        alignItems: "center",
        boxSizing:'border-box'
      },
      headerClass: "break-word column-user-contact-header",
      classChildName: "break-word cursor-pointer column-user-contact-header",
      headerStyle: {
        padding: childTrPadding,
        textAlign: "left",
        width: "20vw !important",
      },
      header: () => <span>{t("supervisor.action")}</span>,
      accessor: "action",
      accessorKey: "action",
      show: userRole != USERTYPES.FIRMDOCTOR && userRole != USERTYPES.FIRMTECHNICIAN ? true : false,
      cell: (cell) => (
        <>
          {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
          {((userRole === USERTYPES.FIRMADMIN || userRole === USERTYPES.RADIOLOGIST) &&
            cell.row.original.status !== "Active") ||
          (userRole === USERTYPES.ADMIN &&
            cell.row.original.active === false) ? (
            <PrimaryButton
              text={t("hospital.activate")}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          ) : (
            <DefaultButton
              text={t("hospital.deactivate")}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleClickGroup(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
              }}
            />
          )}
        </>
      ),
    },
  ];
};
export default ColumnsClient;
